// src/config/seo.js

export const SEO_CONFIG = {
  siteUrl: "https://boxcollider.com.mx",
  defaultTitle: {
    es: "Box Collider",
    en: "Box Collider",
  },
  defaultDescription: {
    es: "Desarrollo de software interactivo.",
    en: "Interactive software development.",
  },
  defaultKeywords: {
    es: "Box Collider, desarrollo de software, desarrollo web, aplicaciones, realidad aumentada, realidad virtual, desarrollo de videojuegos, elementos virtuales, we create the impossible",
    en: "Box Collider, software development, web development, applications, augmented reality, virtual reality, game development, virtual elements, we create the impossible",
  },
};

// Home específica
export const getHomeSeo = (lang = "es") => {
  const langKey = lang.startsWith("en") ? "en" : "es";

  const title = SEO_CONFIG.defaultTitle[langKey];
  const description = SEO_CONFIG.defaultDescription[langKey];
  const keywords = SEO_CONFIG.defaultKeywords[langKey];

  return {
    title,
    description,
    keywords,
    canonical: `${SEO_CONFIG.siteUrl}/`,
  };
};

// Helper genérico por si luego agregas más páginas
export const getPageSeo = ({ lang = "es", title, description, path = "/" }) => {
  const langKey = lang.startsWith("en") ? "en" : "es";

  const baseTitle = SEO_CONFIG.defaultTitle[langKey];
  const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;

  return {
    title: fullTitle,
    description: description || SEO_CONFIG.defaultDescription[langKey],
    canonical: `${SEO_CONFIG.siteUrl}${path}`,
  };
};